let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i1HRw")).then(() => parcelRequire('8pPPY'));